export default __webpack_public_path__ + "1b7f1d5dee0e3043bdb709a6d8af6cde.otf";